//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilter from '../../../../components/Products/sKPI/Board/CalendarFilter';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric, useGetBoardStructureSpecific, useGetBoardVariableDataSerieValues } from '../useOfBoard';
import { mergeStyleSets } from '@fluentui/react';
import { Card } from 'react-bootstrap';
import BoardComponentContent from '../ComponentManager/BoardComponentContent';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import CCardTitle from '../../../../components/Templates/CCard/TitleCard';
import ToolBar from '../../../../components/Common/Toolbar';
import SidePanelDataserieAssociation from '../../../../components/Products/sKPI/Board/BoardBox/Containers/DataserieAssociation/SidePanelDataserieAssociation';
import Loading from '../../../../components/Templates/Site/Loading';
import BoardAppContext from '../../../../BoardAppContext';
import { useGetBoardElementsRoles } from '../../../../hooks/services/sKPI/useOfBoard';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';

function Board(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const queryStringBoardTypeId = props.match.params.boardTypeId !== null && props.match.params.boardTypeId !== undefined && props.match.params.boardTypeId !== "" ? props.match.params.boardTypeId : null;
    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;

    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardPageRedy: boardPageRedy } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    
    const ResponsiveGridLayout = WidthProvider(Responsive);
    const hasPageElementId = true;
    const inputParam_HideHeader = false;

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    };

    const [structureFireGetData, setStructureFireGetData] = useState(true);

    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [boardStructureGeneric, setBoardStructureSpecific] = useState(null)
    const [boardVariableDataserieValues, setBoardVariableDataserieValues] = useState(null)

    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(queryStringBoardTypeId, !isNullUndefinedOrEmpty(boardStructureGeneric) ? (boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : 0) : 0, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)
    
    const boardContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        } 
    }

    useGetBoardStructureGeneric(queryStringBoardTypeId, queryStringElementId, boardStructureGeneric, setBoardStructureSpecific);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, queryStringElementId, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);

    useGetBoardElementsRoles(queryStringElementId, boardElementRoles);

    useGetBoardVariableDataSerieValues(boardStructureGeneric, boardStructureGeneric !== null && boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : null, queryStringElementId, null, contextSite.kpiModule.boardCalendarFilterConfig, boardVariableDataserieValues, setBoardVariableDataserieValues)

    const [isEditDataserieAssociationPanelOpen, setIsEditDataserieAssociationPanelOpen] = useState(false);
    const [isEditTitleMode, setIsEditTitleMode] = useState(false);

    const onOpenEditAssociationDataseries = () => {
        setIsEditDataserieAssociationPanelOpen(true);
    };

    const onChangeEditTitleMode = () => {
        setIsEditTitleMode(true);
    };

    const generateContainerInfo = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={queryStringElementId}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={queryStringBoardTypeId}
                                            inputParam_BoardId={boardStructureGeneric[0].id}
                                            inputParam_ContextualChart={false}
                                            //[#NEW#]
                                            setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        <SidePanelDataserieAssociation
                                            inputParam_BoardId={boardStructureGeneric.boardId}
                                            inputParam_ContainerId={container.id}
                                            inputParam_DataSerieList={container.l_components}
                                            inputParam_IsPanelOpen={isEditDataserieAssociationPanelOpen}
                                            inputParam_SetterIsPanelOpen={setIsEditDataserieAssociationPanelOpen}
                                        />
                                    </div>
                        })
                    }
                </>
    };

    const overflowItems = [
        {
            key: 'editTitle',
            text: t('data-lang-btn-edittitle'),
            iconProps: { iconName: 'Edit' },
            onClick: onChangeEditTitleMode,
        },{
            key: 'modifydataserieassociation',
            text: t('data-lang-btn-editdataseries') ,
            iconProps: { iconName: 'Edit' },
            onClick: () => onOpenEditAssociationDataseries(true),
        }
    ]

    const generateContainerDs = (boardStructure, container) => {
        return  <Card className='h-100'>
                    {
                        !inputParam_HideHeader &&
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                                <CCardTitle
                                    inputParam_CustomTitle={container.title}
                                    inputParam_DefaultTitle={t('data-lang-boxname-dataserielist')}
                                    inputParam_ContainerId={container.id}
                                    inputParam_EditMode={isEditTitleMode}
                                    inputParam_SetterIsEditTitleMode={setIsEditTitleMode}
                                />
                                <div className='toolbar d-flex'>
                                    <ToolBar overflowItems={ overflowItems } display={true} styles={{root: {padding: 0, height: "30px"}}} />
                                </div>
                            </Card.Title>
                        </Card.Header>
                    }
                    <Card.Body className='px-1 py-0 h-100' style={{ overflowY: "auto", overflowX: "auto" }}>
                        {
                            container.l_components.map((component, index) => {
                                return  <div key={index}>
                                            <BoardComponentContent
                                                inputParam_UserPropsKpi={userPropsKpi}
                                                inputParam_ElementId={queryStringElementId}
                                                inputParam_ContainerComponent={component}
                                                inputParam_ContainerComponentIndex={index}
                                                inputParam_BoardId={boardStructureGeneric[0].id}
                                                setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                                            />
                                        </div>         
                            })
                        }
                    </Card.Body>
                </Card>
    };

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                <BoardAppContext.Provider value={ boardContextStructure }>
                {
                    boardPageRedy &&
                    <>
                        {
                            boardStructureGeneric && userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                            <>
                                <CalendarFilter inputParam_BoardId={boardStructureGeneric.boardId} inputParam_ForceShowCalendar={true} />
                                {
                                    boardComponentInfoRecursiveValues &&
                                    boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                        return <div key={indexBoardStructure}>
                                            {
                                                boardStructure.l_structure.length === 1 &&
                                                <ResponsiveGridLayout
                                                    measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                    breakpoints={layoutConfiguration.breakpoints}
                                                    cols={layoutConfiguration.cols}
                                                    rowHeight={layoutConfiguration.rowHeight}
                                                    isDraggable={false}
                                                    isDroppable={false}
                                                    isResizable={false}
                                                    //onLayoutChange={onLayoutChange}
                                                    //onResize={onResize}
                                                    //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                    margin={[10, 10, 10, 10]}
                                                >
                                                    {
                                                        boardStructure.l_structure[0].l_container.map((container, index) => (
                                                            <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                {generateContainerInfo(boardStructure, container)}
                                                                { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                            </div>
                                                        ))
                                                    }
                                                </ResponsiveGridLayout>
                                            }
                                            {
                                                boardStructure.l_structure.length > 1 &&
                                                boardStructure.l_structure.map((structure, index) => {
                                                    return <ResponsiveGridLayout
                                                        key={index}
                                                        breakpoints={{ lg: 1200, xs: 480 }}
                                                        cols={ { lg: 12, xs: 6 } }
                                                        rowHeight={ structure.htmlStructure.rowHeight }
                                                        //onLayoutChange={onLayoutChange}
                                                        //onResize={onResize}
                                                        //draggableHandle={ boardMoveZones ? ".dragHandle" : '.no-drag'}
                                                        margin={[10, 10, 10, 10]}
                                                    >
                                                        {
                                                            structure.l_container.map((container, index) => (
                                                                <div key={index} className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                    {generateContainerInfo(container)}
                                                                    { container.l_components.length > 0 && boardVariableDataserieValues && generateContainerDs(boardStructure, container)}
                                                                </div>
                                                            ))
                                                        }
                                                    </ResponsiveGridLayout>
                                                })
                                            }
                                            
                                        </div>
                                    }) 
                                }
                            </>
                        }
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                            <div className="pt-5 mt-4">
                                <MessageBox  
                                    inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </div>
                        } 
                    </>
                }
                {
                    !boardPageRedy &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                }   
                </BoardAppContext.Provider>
            </>
    );
}

export default Board;